import { FormControl } from '@angular/forms';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { SideNaveData } from '@klickdata/core/mobile';
import { Subject } from 'rxjs';
import { SideNaveActionsTypes, SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';

@Component({
    selector: 'app-menu-side-add-notes-comment',
    templateUrl: './menu-side-add-notes-comment.component.html',
    styleUrls: ['./menu-side-add-notes-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideAddNotesCommentComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public comment = new FormControl();
    public media_ids = new FormControl([]);
    public ai_generated_control: FormControl = new FormControl(false);
    public buttonDisabled: boolean;
    public saving: Subject<boolean> = new Subject<boolean>();
    constructor() {}

    ngOnInit(): void {}
    submit() {
        this.onClose.emit({
            action: SideNaveActionsTypes.POSITIVE,
            data: { comment: this.comment.value, media_ids: this.media_ids.value, type: this.navData.data.type },
        });
    }
}
